import React, { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { Context } from "../..";

type FormValues = {
  email: string;
};

const RestoreForm: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string | null>(null);
  const { store } = React.useContext(Context);
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors }, setError } = useForm<FormValues>();

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    const response = await store.restoreLink(data.email);
    if (response?.status === 200) {
      setMessage('Лист для відновлення пароля було відправлено. Будь ласка, перевірте вашу пошту.');
      setTimeout(() => navigate('/login'), 5000); // Через 5 секунд перенаправити на сторінку входу
    } else {
      setError('email', { type: 'manual', message: response?.data?.message || 'Помилка відновлення' });
    }
  };

  return (
    <>
      {message && <div className="message">{message}</div>}
      <form onSubmit={handleSubmit(onSubmit)} className="form__block">
        <fieldset className="form__field">
          <label htmlFor="email" className="form__label">Ваш email</label>
          <input
            {...register('email', { required: 'Це поле обов`язкове', pattern: /^\S+@\S+\.\S+$/ })}
            className={`form__input ${errors.email ? 'invalid' : ''}`}
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {errors.email && <p className="error-message">{errors.email.message}</p>}
        </fieldset>
        <button className="form__submit" type="submit">Відновити пароль</button>
      </form>
    </>
  );
};

export default observer(RestoreForm);
